// extracted by mini-css-extract-plugin
module.exports = {"label":"style__label__SL+xP"};